import React from "react";
import { useSelector } from "react-redux";
import { staticURLs } from "../../../../config/urls";
import { ApplicationState } from "../../../../store";

const InAppDetails = (props: any) => {
    const inAppDetails = props.billingInfo.inAppDetails;
    let showInAppDetails = false;
    let paymentTypeMessage = "";
    let appStoreURL = "";
    const isBusinessUser = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.isBusinessUser
            ? state.loggedInUser.userServiceDetails.isBusinessUser
            : false
    );

    if (inAppDetails && inAppDetails.paymentType) {
        showInAppDetails = true;
        paymentTypeMessage = inAppDetails.paymentType === "Google" ? "Google Play" : "iOS App";
        if (isBusinessUser) {
            appStoreURL = inAppDetails.paymentType === "Google" ? staticURLs.BusinessUserAndroidApp : staticURLs.BusinessUseriOSApp;
        } else if (props.isIDFUser) {
            appStoreURL = inAppDetails.paymentType === "Google" ? staticURLs.IDFAndroidApp : staticURLs.IDFiOSAPP;
        } else {
            appStoreURL = inAppDetails.paymentType === "Google" ? staticURLs.EzsAndroidApp : staticURLs.EzsiOSAPP;
        }
    }

    const penAppStore = () => {
        window.open(appStoreURL);
    };

    return (
        <React.Fragment>
            {showInAppDetails ? (
                <React.Fragment>
                    <div className="margin-top-l"></div>
                    <div className="box-title-text">
                        <h3 className="content-sub-title">Add-Ons</h3>
                    </div>
                    <div role="grid" className="data-grid " id="billing-grid" aria-hidden="false">
                        <div role="row" className="data-row row">
                            <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                <div className="data-label" id="label-billing-payment-history">
                                    Mobile Attack Control
                                </div>
                            </div>
                            <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                <div className="data-value" aria-labelledby="label-billing-payment-history">
                                    <a onClick={penAppStore} href="javascript:void(0);" className="default_link">
                                        {"Manage subscription on " + paymentTypeMessage + " Store"}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            ) : (
                <React.Fragment></React.Fragment>
            )}
        </React.Fragment>
    );
};

export default InAppDetails;
